import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import '../responsive.css'
import '@fontsource/inter'
import { sendOtpApi } from '../services/authApi'


function Login() {
  const navigate = useNavigate()
  const [mobile, setMobile] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [activeSlide, setActiveSlide] = useState(0)

  const slides = [
    {
      image: '/slide-1.png',
      title: 'Smart Digital Khata for Modern Business',
      text: 'Track customer & supplier balances, send automated payment reminders, and keep 100% secure ledger.',
    },
    {
      image: '/slide-billing.jpg',
      title: 'Superfast Invoicing & GST Billing',
      text: 'Create GST and Non-GST bills, print thermal receipts, and share professional PDF invoices on WhatsApp in 1-click.',
    },
    {
      image: '/slide-marketplace.jpg',
      title: 'Grow With Local Online Marketplace',
      text: 'Take your shop online, list products and services with images & prices, and receive direct customer orders.',
    },
    {
      image: '/slide-2.png',
      title: 'Track Customer Payments Easily',
      text: 'Send automated WhatsApp reminders, collect payments faster, and manage every transaction with ease.',
    },
    {
      image: '/slide-3.png',
      title: 'Grow Faster With Business Reports',
      text: 'Get smart insights, monitor cash flow & profits, and make confident business decisions with detailed analytics.',
    },
  ]

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % slides.length)
    }, 3500)

    return () => clearInterval(interval)
  }, [slides.length])

  const handleSendOtp = async () => {
    setError('')

    if (!mobile) {
      setError('Please enter mobile number')
      return
    }

    if (mobile.length !== 10) {
      setError('Enter valid 10-digit mobile number')
      return
    }

    setLoading(true)

    const response = await sendOtpApi(mobile)

console.log('SEND OTP RESPONSE:', response)

if (response?.status === true || response?.status === 'true') {
  console.log('NAVIGATING TO OTP SCREEN')
  navigate('/verify-otp', { state: { mobile } })
} else {
  setError(response?.message || 'Failed to send OTP')
}

    setLoading(false)
  }

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

  useState(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <div style={{
      ...styles.page, 
      padding: isMobile ? '10px' : '20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }} className="app-page">
      <div style={{
        ...styles.topBar,
        width: '100%',
        borderRadius: isMobile ? '12px' : '18px',
        padding: isMobile ? '10px 14px' : '14px 20px',
        marginBottom: isMobile ? '10px' : '14px'
      }}>
        <div style={{...styles.topBrand, justifyContent: isMobile ? 'center' : 'flex-start'}}>
          <img src="/logo.png" alt="Moxpal Logo" style={{...styles.topLogo, height: isMobile ? '28px' : '32px'}} />
          <span style={{...styles.topBrandText, fontSize: isMobile ? '14px' : '16px'}}>Moxpal Khata Web</span>
        </div>
      </div>

      <div style={{
        ...styles.wrapper,
        width: '100%',
        gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
        minHeight: isMobile ? 'calc(100vh - 80px)' : 'calc(100vh - 110px)',
        borderRadius: isMobile ? '20px' : '24px',
      }} className="app-wrapper">
        
        {/* LEFT - Hidden on mobile for cleaner login */}
        {!isMobile && (
          <div style={styles.leftPanel} className="left-panel">
            <div style={styles.leftContent}>
              <img
                src={slides[activeSlide].image}
                alt="Business Illustration"
                style={styles.heroIllustration}
              />

              <h2 style={styles.leftTitle}>{slides[activeSlide].title}</h2>
              <p style={styles.leftText}>{slides[activeSlide].text}</p>

              <div style={styles.dotWrap}>
                {slides.map((_, index) => (
                  <span
                    key={index}
                    onClick={() => setActiveSlide(index)}
                    style={{
                      ...styles.dot,
                      ...(activeSlide === index ? styles.dotActive : {}),
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        )}

        {/* RIGHT */}
        <div style={{
          ...styles.rightPanel,
          padding: isMobile ? '30px 16px' : '40px'
        }} className="right-panel">
          <div style={{
            ...styles.loginCard,
            maxWidth: isMobile ? '100%' : '420px'
          }} className="login-card">
            <div style={styles.loginLogoWrap}>
              <img
                src="/praying-hands.png"
                alt="Welcome"
                style={{...styles.loginLogo, height: isMobile ? '44px' : '54px'}}
              />
            </div>

            <h1 style={{
              ...styles.loginTitle,
              fontSize: isMobile ? '24px' : '28px',
              lineHeight: isMobile ? '32px' : '36px'
            }} className="login-title">
              Welcome to Moxpal Khata
            </h1>

            <p style={{...styles.loginSubtitle, fontSize: isMobile ? '14px' : '15px'}}>
              Enter your mobile number to continue
            </p>

            <label style={styles.label}>Mobile Number</label>

            <div style={styles.inputWrap}>
              <div style={styles.countryCode}>+91</div>
              <input
                type="text"
                placeholder="Please enter mobile number"
                style={styles.input}
                value={mobile}
                onChange={(e) =>
                  setMobile(e.target.value.replace(/\D/g, '').slice(0, 10))
                }
              />
            </div>

            <p style={styles.infoText}>
              We will send a 6 digit OTP to verify your mobile number securely.
            </p>

            {error && <p style={styles.errorText}>{error}</p>}

            <button
              style={styles.button}
              onClick={handleSendOtp}
              disabled={loading}
            >
              {loading ? 'Sending OTP...' : 'Verify Mobile With OTP'}
            </button>

            <p style={styles.terms}>
              By continuing, you agree to our{' '}
              <a
                href="https://khata.moxpal.com/terms-conditions"
                target="_blank"
                rel="noopener noreferrer"
                style={styles.link}
              >
                Terms of Service
              </a>{' '}
              and{' '}
              <a
                href="https://khata.moxpal.com/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                style={styles.link}
              >
                Privacy Policy
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

const styles = {
  page: {
    width: '100%',
    minHeight: '100vh',
    padding: '20px',
    backgroundColor: '#F8FAFC',
    fontFamily: 'Inter, Arial, sans-serif',
  },

  topBar: {
    width: '100%',
    maxWidth: '1320px',
    margin: '0 auto 14px auto',
    backgroundColor: '#ffffff',
    borderRadius: '18px',
    padding: '14px 20px',
    boxShadow: '0 8px 24px rgba(15,23,42,0.04)',
  },

  topBrand: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },

  topLogo: {
    height: '32px',
  },

  topBrandText: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#0F172A',
  },

  wrapper: {
    width: '100%',
    maxWidth: '1320px',
    minHeight: 'calc(100vh - 110px)',
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    backgroundColor: '#ffffff',
    borderRadius: '24px',
    overflow: 'hidden',
    boxShadow: '0 12px 40px rgba(15,23,42,0.06)',
  },

  leftPanel: {
    padding: '34px 40px',
    borderRight: '1px solid #E2E8F0',
    display: 'flex',
    backgroundColor: '#ffffff',
  },

  leftContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },

  heroIllustration: {
    width: '100%',
    maxWidth: '300px',
    height: '240px',
    objectFit: 'contain',
    borderRadius: '16px',
    marginBottom: '20px',
  },

  leftTitle: {
    fontSize: '28px',
    lineHeight: '38px',
    fontWeight: '600',
    color: '#0F172A',
    marginBottom: '12px',
    maxWidth: '520px',
  },

  leftText: {
    fontSize: '15px',
    lineHeight: '26px',
    color: '#64748B',
    maxWidth: '500px',
    marginBottom: '26px',
    fontWeight: '400',
  },

  dotWrap: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },

  dot: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: '#CBD5E1',
    cursor: 'pointer',
  },

  dotActive: {
    backgroundColor: '#2563EB',
  },

  rightPanel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px',
    backgroundColor: '#ffffff',
  },

  loginCard: {
    width: '100%',
    maxWidth: '420px',
  },

  loginLogoWrap: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '16px',
  },

  loginLogo: {
    height: '54px',
    objectFit: 'contain',
  },

  loginTitle: {
    textAlign: 'center',
    fontSize: '28px',
    lineHeight: '36px',
    fontWeight: '600',
    color: '#0F172A',
    marginBottom: '8px',
  },

  loginSubtitle: {
    textAlign: 'center',
    fontSize: '15px',
    color: '#64748B',
    marginBottom: '26px',
    fontWeight: '400',
  },

  label: {
    display: 'block',
    fontSize: '13px',
    fontWeight: '500',
    color: '#334155',
    marginBottom: '8px',
  },

  inputWrap: {
    display: 'flex',
    alignItems: 'center',
    border: '1.5px solid #CBD5E1',
    borderRadius: '12px',
    overflow: 'hidden',
    marginBottom: '14px',
    backgroundColor: '#fff',
  },

  countryCode: {
    padding: '14px 16px',
    backgroundColor: '#F8FAFC',
    fontSize: '14px',
    fontWeight: '600',
    borderRight: '1px solid #E2E8F0',
  },

  input: {
    flex: 1,
    border: 'none',
    outline: 'none',
    padding: '14px',
    fontSize: '14px',
    fontFamily: 'Inter, Arial, sans-serif',
  },

  infoText: {
    fontSize: '13px',
    lineHeight: '20px',
    color: '#94A3B8',
    marginBottom: '14px',
    fontWeight: '400',
  },

  errorText: {
    fontSize: '13px',
    color: '#DC2626',
    marginBottom: '14px',
  },

  button: {
    width: '100%',
    height: '52px',
    border: 'none',
    borderRadius: '14px',
    backgroundColor: '#2563EB',
    color: '#fff',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    marginBottom: '20px',
  },

  terms: {
    textAlign: 'center',
    fontSize: '13px',
    lineHeight: '22px',
    color: '#64748B',
    fontWeight: '400',
  },

  link: {
    color: '#2563EB',
    fontWeight: '500',
    cursor: 'pointer',
    textDecoration: 'none',
  },
}

export default Login